import { Alert, Box, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { useStreamData } from "../hooks/useStreamData";
import StreamFinancialReport from "./StreamFinancialReport";

const StreamFinancialReportPage = () => {
  const { id } = useParams<{ id: string }>();
  const streamId = id ? Number.parseInt(id, 10) : Number.NaN;
  const { stream, isLoading, error } = useStreamData(id);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!Number.isFinite(streamId) || error || !stream) {
    return (
      <Alert severity="error">
        {error || "The stream could not be loaded."}
      </Alert>
    );
  }

  return <StreamFinancialReport streamId={streamId} stream={stream} active />;
};

export default StreamFinancialReportPage;
